import { Injectable, inject } from '@angular/core';
import { ApiContextService } from '../../services/api-context/api-context.service';
import { filter, Observable, switchMap } from 'rxjs';
import { HttpService, UrlService } from '@boels/helpers';
import { BoelsReservation, ParamsModel } from '@boels/models';

@Injectable({
  providedIn: 'any',
})
export class HolidaysGateway {
  private readonly httpService = inject(HttpService);
  private urlService = inject(UrlService);
  private apiContextService = inject(ApiContextService);

  getHolidays(periodStart: string, periodEnd: string): Observable<any> {
    return this.apiContextService.getContext().pipe(
      filter(([baseSite]) => !!baseSite),
      switchMap(([baseSite]) => {
        const queryParams: ParamsModel = [
          ['periodStart', periodStart],
          ['periodEnd', periodEnd],
        ];
        const url: string = this.urlService.combineUri(
          baseSite.uid,
          'calendar',
        );
        return this.httpService.get<BoelsReservation>(url, queryParams);
      }),
    );
  }
}
